<template>
  <div class="event-sebexponent-card">
    <div class="event-sebexponent-card__left">
      <h2 class="event-sebexponent-card__left-title">
        {{ $t("event.subexponent.title") }}
      </h2>

      <p
        class="event-sebexponent-card__left-text"
        v-html="$t('event.subexponent.totalArea', { area: event.area || 0 })"
      ></p>

      <icon
        name="event-users-header"
        class="event-sebexponent-card__left-img"
      />
    </div>

    <div class="event-sebexponent-card__right">
      <div class="event-sebexponent-card__right-faculty">
        <p class="event-sebexponent-card__right-faculty-text">
          {{ $t("event.subexponent.withDeligatedAccess") }}
        </p>
        <span class="event-sebexponent-card__right-faculty-value">
          <span>{{ countSubParticipantsEditAccess }}</span>

          {{
            countSubParticipantsEditAccess
              | pluralize($t("event.subexponent.pluralize"))
          }}
        </span>
      </div>
      <div class="event-sebexponent-card__right-faculty">
        <p class="event-sebexponent-card__right-faculty-text">
          {{ $t("event.subexponent.withReadAccess") }}
        </p>
        <span class="event-sebexponent-card__right-faculty-value">
          <span>{{ countSubParticipantsReadAccess }}</span>

          {{
            countSubParticipantsEditAccess
              | pluralize($t("event.subexponent.pluralize"))
          }}
        </span>
      </div>
      <div class="event-sebexponent-card__right-action">
        <template v-if="hasAccessToWrite">
          <PrimaryButton
            v-if="
              !countSubParticipantsEditAccess && !countSubParticipantsReadAccess
            "
            @click="$modal.show('event-modal-subexponent')"
          >
            {{ $t("event.subexponent.addSubexponentBtn") }}
          </PrimaryButton>

          <LinkIcon
            icon="link-icon-edit"
            v-else
            @click="$modal.show('event-modal-subexponent')"
            :bold="true"
          >
            {{ $t("event.subexponent.manageSubexponentsBtn") }}
          </LinkIcon>
        </template>
        <template v-else>
          <LinkIcon
            icon="look"
            @click="$modal.show('event-modal-subexponent')"
            :bold="true"
          >
            {{ $t("event.subexponent.lookSubexponentsBtn") }}
          </LinkIcon>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { PrimaryButton, LinkIcon } from "@v2/shared/ui/components";

export default {
  components: {
    PrimaryButton,
    LinkIcon
  },

  computed: {
    ...mapState("event", ["event", "subParticipants"]),

    ...mapGetters("event", [
      "hasAccessToWrite",
      "countSubParticipantsReadAccess",
      "countSubParticipantsEditAccess"
    ])
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/mixins";
@import "@v2/app/styles/media";

.event-sebexponent-card {
  width: 100%;
  margin-top: 24px;
  display: flex;

  @include respond-down(md) {
    flex-direction: column;
  }

  &__left {
    max-width: 298px;
    width: 100%;
    border-right: 2px solid #f1f1f1;
    padding: 28px 39px 40px 39px;
    box-sizing: border-box;

    position: relative;

    @include respond-down(lg) {
      padding: 20px 0 19px 24px;
      max-width: 258px;
    }

    @include respond-down(md) {
      border-right: none;
      border-bottom: 2px solid #f1f1f1;

      max-width: 100%;
    }

    &-img {
      position: absolute;
      right: 15px;
      top: 50%;
      transform: translateY(-50%);
      width: 80px;
      height: 80px;

      display: none;

      @include respond-down(md) {
        display: block;
      }
    }
    &-title {
      @include h2();
      margin-bottom: 84px;

      @include respond-down(md) {
        margin-bottom: 12px;
      }
    }

    &-text {
      @include description();
    }
  }

  &__right {
    display: flex;
    flex-direction: column;

    padding: 33px 0 32px 61px;

    @include respond-down(lg) {
      padding: 28px 0 24px 47px;
    }

    @include respond-down(md) {
      padding: 20px 0 19px 24px;
    }

    &-faculty {
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      max-width: 370px;
      width: 100%;
      margin: 0 0 20px 0;

      @include respond-down(md) {
        flex-direction: column;
      }

      &-text {
        font-size: 14px;
        font-weight: 500;
        line-height: 1.43;
        color: #000000;

        margin: 0 45px 0 0;
        padding: 0;
      }

      &-value {
        @include description();
      }
    }

    &-action {
      margin: 15px 0 0 0;
    }
  }
}
</style>
